export default __webpack_public_path__ + "static/media/IMG_5108_min.1ca18923.png";